(() => {
  function initialise(root) {
    const article = root.querySelector('[data-sh-listicle]');
    if (!article || article.dataset.ready) return;
    article.dataset.ready = 'true';
    const incoming = new URLSearchParams(window.location.search);
    article.querySelectorAll('.product-link').forEach(link => {
      const target = new URL(link.getAttribute('href'), window.location.origin);
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid'].forEach(key => {
        if (incoming.has(key)) target.searchParams.set(key, incoming.get(key));
      });
      link.href = target.toString();
    });
    const bar = article.querySelector('.mobile-buy');
    const hero = article.querySelector('.hero-copy');
    if (!bar || !hero) return;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        bar.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      observer.observe(hero);
      article.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
    } else bar.classList.add('visible');
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
